// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JT9v","title":"styles_title__2MjkT"};